export const CREDIT_CARDS = {
    CARD_VISA: 'visa',
    CARD_VISA_ELECTRON: 'visaelectron',
    CARD_DISCOVER: 'discover',
    CARD_MASTER_CARD: 'mastercard',
    CARD_AMERICAN_EXPRESS: 'amex',
};

export const FIELDS = {
    FIELD_CARD_HOLDER_NAME: 'cardHolderName',
    FIELD_CARD_NUMBER: 'creditCardNumber',
    FIELD_SECURITY_CODE: 'securityCode',
    FIELD_EXPIRY: 'cardExpiry',
};

export const cards = [
    CREDIT_CARDS.CARD_VISA,
    CREDIT_CARDS.CARD_VISA_ELECTRON,
    CREDIT_CARDS.CARD_DISCOVER,
    CREDIT_CARDS.CARD_MASTER_CARD,
    CREDIT_CARDS.CARD_AMERICAN_EXPRESS,
];

export const fields = [
    FIELDS.FIELD_CARD_HOLDER_NAME,
    FIELDS.FIELD_CARD_NUMBER,
    FIELDS.FIELD_SECURITY_CODE,
    FIELDS.FIELD_EXPIRY,
];

export const regexMap = {
    specialCharacters: /[!@#$%^&*()+=><?]/,
};
